import { useQuery } from 'react-apollo';
import { gql } from '@apollo/client';

import { ConfluencePageAri } from '@atlassian/ari';

import { fg } from '@confluence/feature-gating';
import { usePageContentId } from '@confluence/page-context';
import { useSessionData } from '@confluence/session-data';

const useWorkflowStatusQuery = gql`
	query useWorkflowStatusQuery($contentId: ID!) {
		confluence_workflowApplicationsByContentId(contentId: $contentId, first: 50) {
			nodes {
				currentWorkflowStatus {
					id
					displayProperties {
						name
						color
					}
				}
				availableTransitions {
					id
					displayProperties {
						name
						description
					}
					startStatus {
						displayProperties {
							name
						}
					}
					destinationStatus {
						displayProperties {
							name
						}
					}
				}
			}
		}
	}
`;

export const useWorkflowStatus = () => {
	const { cloudId } = useSessionData();
	const [contentId] = usePageContentId();

	const pageAri = contentId
		? ConfluencePageAri.create({
				siteId: cloudId,
				pageId: contentId,
			}).toString()
		: undefined;

	const { data, loading, error } = useQuery(useWorkflowStatusQuery, {
		skip: !pageAri || !fg('document_workflows'),
		variables: {
			contentId: pageAri,
		},
	});

	const workflowStatus = data?.confluence_workflowApplicationsByContentId?.nodes?.[0];

	return {
		workflowStatus,
		loading,
		error,
	};
};
